import * as sessionState from './sessionState';

export default (): {} | undefined => (process.env.NODE_ENV === 'development' ? sessionState.get() : undefined);



// WEBPACK FOOTER //
// ./src/application/core/getPreloadedState.ts